<template>
    <k-page>
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container size="lg" class="pb-20 mt-8">
         <div class="mb-5" style="display: flex; justify-content: flex-end;">
           <a-button type="primary" v-if="!$root.$data.investorProfile.vwoFeatures.goBackToReact.goBackToReactButtonHide" @click="this.$goBackToNewPlatform">Go back to new UI</a-button>
         </div>
            <div v-if="!tranches" class="text-lg text-gray-700">
                {{ $t("noTranchesAvailable") }}
            </div>

            <tranche-list
                :tranches="tranches"
                @invest="invest"
            />
        </k-container>
    </k-page>
</template>

<script>
import ProfileHeader from '@investor/components/profile/ProfileHeader';
import TrancheList from '@product-common/components/tranches2/TrancheList';

export default {
        components: {
            ProfileHeader,
            TrancheList
        },
        data() {
            return {
                loading: false,
                tranches: [],
                form: {
                    ordering: [{
                        field: 'maturity_date',
                        asc: true,
                    }],
                    page: 1,
                    pageSize: 1000,
                },
            }
        },
        async mounted() {
            await this.refresh();
        },
        methods: {
            async refresh() {
                let resp = await this.$post('tranche-listing', this.form);
                this.tranches = resp.items;
            },
            invest(trancheUuid) {
                this.$router.push({name: 'tranche-invest', params: {trancheUuid: trancheUuid}});
            },
        }
    }
</script>


